import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import { LocaleProvider } from "@/i18n";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Privacidad from "@/pages/Privacidad";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Contactos from "@/pages/Contactos";
import ContactoDetalle from "@/pages/ContactoDetalle";
import Pipeline from "@/pages/Pipeline";
import Ruta from "@/pages/Ruta";
import Equipo from "@/pages/Equipo";
import Correos from "@/pages/Correos";
import Ajustes from "@/pages/Ajustes";
import Desarrollo from "@/pages/Desarrollo";
import { AppLayout } from "@/components/AppLayout";

function FullLoader() {
    return (
        <div className="grid min-h-screen place-items-center bg-nm-bg">
            <div className="flex flex-col items-center gap-4">
                <div className="grid h-11 w-11 place-items-center rounded-xl bg-nm-accent text-white">
                    <span className="text-lg font-bold">N</span>
                </div>
                <div className="skeleton h-1 w-32 rounded-full" />
            </div>
        </div>
    );
}

function Protected({ children, requireOnboarding = true, bare = false }) {
    const { user } = useAuth();
    if (user === null) return <FullLoader />;
    if (user === false) return <Navigate to="/entrar" replace />;
    if (requireOnboarding && !user.onboarding_completed) return <Navigate to="/onboarding" replace />;
    if (bare) return children;
    return <AppLayout>{children}</AppLayout>;
}

function PublicOnly({ children }) {
    const { user } = useAuth();
    if (user === null) return <FullLoader />;
    if (user) return <Navigate to="/app" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <LocaleProvider>
                    <ConfigProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route path="/privacidad" element={<Privacidad />} />
                                <Route path="/entrar" element={<PublicOnly><Login /></PublicOnly>} />
                                <Route path="/registro" element={<PublicOnly><Register /></PublicOnly>} />
                                <Route path="/recuperar" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
                                <Route path="/restablecer" element={<ResetPassword />} />

                                <Route path="/onboarding" element={
                                    <Protected requireOnboarding={false} bare><Onboarding /></Protected>
                                } />
                                <Route path="/app" element={<Protected><Dashboard /></Protected>} />
                                <Route path="/app/contactos" element={<Protected><Contactos /></Protected>} />
                                <Route path="/app/contactos/:id" element={<Protected><ContactoDetalle /></Protected>} />
                                <Route path="/app/pipeline" element={<Protected><Pipeline /></Protected>} />
                                <Route path="/app/ruta" element={<Protected><Ruta /></Protected>} />
                                <Route path="/app/equipo" element={<Protected><Equipo /></Protected>} />
                                <Route path="/app/desarrollo" element={<Protected><Desarrollo /></Protected>} />
                                <Route path="/app/correos" element={<Protected><Correos /></Protected>} />
                                <Route path="/app/ajustes" element={<Protected><Ajustes /></Protected>} />

                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </BrowserRouter>
                        <Toaster position="top-center" theme="dark" />
                    </ConfigProvider>
                </LocaleProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
